import {
  FETCH_ADMIN_USERS_BEGIN,
  FETCH_ADMIN_USERS_FULFILLED,
  FETCH_ADMIN_USERS_REJECTED
} from "../actions/adminUsersActions";

export function adminUsersReducer(
  state = {
    loading: false,
    result: [],
    error: null
  },
  action
) {
  switch (action.type) {
    case FETCH_ADMIN_USERS_BEGIN: {
      return { ...state, loading: true };
    }

    case FETCH_ADMIN_USERS_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }

    case FETCH_ADMIN_USERS_REJECTED: {
      return { ...state, loading: false, error: action.payload };
    }

    default: {
      return {
        ...state
      };
    }
  }
}
